export class SelectNav extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      this.els.select.element,
      'change',
      this.onSelectChange.bind(this),
    )
  }

  onSelectChange () {
    this.els.button.element.href = this.selectedValue

    this.els.title.element.textContent = this.selectedTitle

    this.els.button.element.ariaHidden = false
  }

  get selectedValue () {
    return this.els.select.element.value
  }

  get selectedTitle () {
    return this.els.select.element.options[
      this.els.select.element.selectedIndex
    ].textContent
  }
}

if (!customElements.get('select-nav')) {
  customElements.define('select-nav', SelectNav)
}
